import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const seetUrl = "https://script.google.com/macros/s/AKfycbw6Zbd_IID6bfA_FfV7YjnC0ukTw3X_sruniC01d0xT9Mi5eZjd35aumwo_Htdn5sXL9w/exec"


export const Form = () => {
    const [formData, setFormData] = useState({
        Name: "",
        Email: "",
        Phone: "",
        Course: "",
        Subject: "",
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validateForm = () => {
        let formErrors = {};

        if (!formData.Name.trim()) formErrors.Name = "Full Name is required";
        if (!formData.Email.trim()) formErrors.Email = "Email is required";
        if (!formData.Phone.trim()) formErrors.Phone = "Phone is required";
        if (!formData.Course.trim()) formErrors.Course = "Course Preferred is required";
        if (!formData.Subject.trim()) formErrors.Subject = "Subject is required";

        return formErrors;
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     const validationErrors = validateForm();
    //     if (Object.keys(validationErrors).length > 0) {
    //         setErrors(validationErrors);
    //         return;
    //     } else {
    //         setErrors({});
    //     }

    //     try {
    //         const res = await axios.post("https://arvservicesconsultant.com/api", formData);
    //         Swal.fire({
    //             title: "Email sent successfully!",
    //             icon: "success",
    //             draggable: true
    //         });
    //         setFormData({
    //             name: "",
    //             email: "",
    //             phone: "",
    //             course: "",
    //             subject: "",
    //         });
    //     } catch (error) {
    //         Swal.fire({
    //             title: "Failed to send email",
    //             icon: "error",
    //             draggable: true
    //         });
    //     }
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        } else {
            setErrors({});
        }

        try {
            const res = await axios.post(seetUrl, formData);
            Swal.fire({
                title: "Email sent successfully!",
                icon: "success",
                draggable: true
            });
            setFormData({
                Name: "",
                Email: "",
                Phone: "",
                Course: "",
                Subject: "",
            });
        } catch (error) {
            Swal.fire({
                title: "Failed to send email",
                icon: "error",
                draggable: true
            });
        }
    };

    return (
        <div className="col-11 rounded-4 bgdmg m-auto">
            <form className="col-11 m-auto text-white text-start" onSubmit={handleSubmit}>

                <label className="mt-3" htmlFor="name">Full Name*</label>
                {errors.Name && <small className="text-danger mx-2">{errors.Name}</small>}
                <input
                    className="form-control"
                    type="text"
                    name="Name"
                    value={formData.Name}
                    onChange={handleChange}
                    placeholder="Enter Your Full Name"
                />

                <label className="mt-3" htmlFor="email">Email*</label>
                {errors.Email && <small className="text-danger mx-2">{errors.Email}</small>}
                <input
                    className="form-control"
                    type="email"
                    name="Email"
                    value={formData.Email}
                    onChange={handleChange}
                    placeholder="Enter Your Email"
                />

                <label className="mt-3" htmlFor="phone">Phone*</label>
                {errors.Phone && <small className="text-danger mx-2">{errors.Phone}</small>}
                <input
                    className="form-control"
                    type="text"
                    name="Phone"
                    value={formData.Phone}
                    onChange={handleChange}
                    placeholder="Enter Phone Number"
                />

                <label className="mt-3" htmlFor="course">Course Preferred*</label>
                {errors.Course && <small className="text-danger mx-2">{errors.Course}</small>}
                <input
                    className="form-control"
                    type="text"
                    name="Course"
                    value={formData.Course}
                    onChange={handleChange}
                    placeholder="Enter Course Preferred"
                />

                <label className="mt-3" htmlFor="subject">Subject*</label>
                {errors.Subject && <small className="text-danger mx-2">{errors.Subject}</small>}
                <textarea
                    className="form-control"
                    name="Subject"
                    value={formData.Subject}
                    onChange={handleChange}
                    placeholder="Enter Your Subject"
                ></textarea>

                <button type="submit" className="btn btn-outline-light rounded-5 my-3">Submit</button>
            </form>
        </div>
    );
};
